function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
/**
 * Poker statistics overlay — presentation only.
 * Values are derived from existing poker.game.stats + tracked_stats metadata.
 * Percentage math matches the previous template (unchanged denominators).
 */

function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function formatStatEntry(playerStats, s) {
  var current_stat = playerStats[s.code];
  if (!(current_stat > 0)) {
    return {
      primary: '—',
      secondary: '',
      isPercent: false
    };
  }
  if (s !== null && s !== void 0 && s.percentage) {
    var denom = playerStats['hands'];
    if (s.percentage == 'adjusted') {
      denom -= playerStats['walks'];
    }
    if (denom > 0) {
      var percent = Math.round(100 * current_stat / denom);
      return {
        primary: "".concat(percent, "%"),
        secondary: "".concat(current_stat, "/").concat(denom),
        isPercent: true
      };
    }
    return {
      primary: '—',
      secondary: '',
      isPercent: true
    };
  }
  return {
    primary: String(current_stat),
    secondary: '',
    isPercent: false
  };
}
module.exports = function (poker, tracked_stats) {
  var players = Object.keys(poker.game.stats || {});
  var playerCount = Math.max(players.length, 1);
  var html = "\n  <form class=\"saito-overlay-form poker-stats-overlay\" id=\"poker-stats-overlay-root\">\n    <header class=\"saito-overlay-form-header\">\n      <h2 class=\"saito-overlay-form-header-title\">Poker Statistics</h2>\n    </header>\n\n    <div class=\"poker-stats-table\" style=\"--poker-stats-players: ".concat(playerCount, "\">\n      <div class=\"poker-stats-row poker-stats-row--header\" role=\"row\">\n        <div class=\"poker-stats-cell poker-stats-cell--label\" role=\"columnheader\"></div>");
  for (var _i = 0, _players = players; _i < _players.length; _i++) {
    var p = _players[_i];
    var name = escapeHtml(poker.app.keychain.returnUsername(p));
    var key = escapeHtml(p);
    html += "\n        <div class=\"poker-stats-cell poker-stats-cell--player\" role=\"columnheader\" title=\"".concat(key, "\">\n          <span class=\"poker-stats-player-name\">").concat(name, "</span>\n        </div>");
  }
  html += "\n      </div>";
  var footnotes = [];
  var _iterator = _createForOfIteratorHelper(tracked_stats),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var s = _step.value;
      var hasNote = !!(s !== null && s !== void 0 && s.further);
      if (hasNote) {
        footnotes.push({
          label: s.readable,
          note: s.further
        });
      }
      var labelClass = hasNote ? 'poker-stats-label poker-stats-label--note' : 'poker-stats-label';
      var labelTitle = hasNote ? " title=\"".concat(escapeHtml(s.further), "\"") : '';
      var labelStar = hasNote ? '*' : '';
      html += "\n      <div class=\"poker-stats-row\" role=\"row\">\n        <div class=\"poker-stats-cell poker-stats-cell--label\" role=\"rowheader\">\n          <span class=\"".concat(labelClass, "\"").concat(labelTitle, ">").concat(escapeHtml(s.readable)).concat(labelStar, "</span>\n        </div>");
      var _iterator3 = _createForOfIteratorHelper(players),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _p = _step3.value;
          var entry = formatStatEntry(poker.game.stats[_p], s);
          var valueClass = entry.isPercent ? 'poker-stats-value poker-stats-value--percent' : 'poker-stats-value poker-stats-value--count';
          html += "\n        <div class=\"poker-stats-cell poker-stats-cell--value\" role=\"cell\">\n          <span class=\"".concat(valueClass, "\">").concat(escapeHtml(entry.primary), "</span>");
          if (entry.secondary) {
            html += "\n          <span class=\"poker-stats-value-detail\">".concat(escapeHtml(entry.secondary), "</span>");
          }
          html += "\n        </div>";
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      html += "\n      </div>";
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  html += "\n    </div>";
  if (footnotes.length) {
    html += "\n    <div class=\"poker-stats-footnotes\">";
    var _iterator2 = _createForOfIteratorHelper(footnotes),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var foot = _step2.value;
        html += "\n      <p class=\"poker-stats-footnote\">\n        <span class=\"poker-stats-footnote-label\">".concat(escapeHtml(foot.label), "*</span>\n        ").concat(escapeHtml(foot.note), "\n      </p>");
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    html += "\n    </div>";
  }
  html += "\n  </form>";
  return html;
};